import api, { handleApiError } from './client';

export const auditLogService = {
  /**
   * Get recent audit logs with pagination and filters
   */
  getRecentLogs: async (limit = 50, entityType = null) => {
    try {
      const response = await api.get('/api/audit/recent', {
        params: {
          limit,
          entityType: entityType || undefined,
        },
      });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      console.error('Error fetching audit logs:', error);
      return handleApiError(error, 'Errore nel caricamento dei log di audit');
    }
  },
};

export default auditLogService;
